import { Alert } from "@justworkshr/milo-core";

const FullPageError = () => (
  <div className="milo--grid">
    <Alert>There was an error loading your data, try again.</Alert>
  </div>
);

export default FullPageError;
